import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw"
}
const _hoisted_2 = {
  key: 1,
  "data-testid": "skeleton",
  class: "py-5 px-6"
}
const _hoisted_3 = {
  key: 2,
  class: "py-5 px-6"
}
const _hoisted_4 = { class: "flex items-center justify-between mb-4" }
const _hoisted_5 = { class: "overflow-x-auto" }
const _hoisted_6 = { class: "w-full border-collapse text-[12.5px]" }
const _hoisted_7 = { class: "bg-[#e7f6ea] border-b-2 border-[#c6ebcf]" }
const _hoisted_8 = { class: "px-2.5 py-2 text-right font-semibold text-[#1b5e20] whitespace-nowrap w-[140px]" }
const _hoisted_9 = { class: "px-2.5 py-2 text-right font-semibold text-[#1b5e20] whitespace-nowrap" }
const _hoisted_10 = { class: "px-2.5 py-2 text-right font-semibold text-[#1b5e20] whitespace-nowrap" }
const _hoisted_11 = { class: "px-2.5 py-2 text-right font-semibold text-[#1b5e20] whitespace-nowrap border-l border-[#c6ebcf]" }
const _hoisted_12 = {
  key: 0,
  class: "px-2.5 py-2 text-left font-semibold text-[#1b5e20] whitespace-nowrap"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = { class: "px-2.5 py-2 align-middle" }
const _hoisted_16 = {
  key: 0,
  "data-cy": "fee-recipient-vendor-text"
}
const _hoisted_17 = { class: "px-2.5 py-2 align-middle" }
const _hoisted_18 = {
  key: 0,
  "data-cy": "fee-recipient-role-text"
}
const _hoisted_19 = { class: "px-2.5 py-2 align-middle text-right tabular-nums" }
const _hoisted_20 = {
  key: 0,
  "data-cy": "fee-recipient-percentage-text"
}
const _hoisted_21 = { class: "px-2.5 py-2 align-middle text-right tabular-nums font-bold text-[#1b5e20]" }
const _hoisted_22 = { class: "px-2.5 py-2 align-middle text-right tabular-nums text-[#555]" }
const _hoisted_23 = { class: "px-2.5 py-2 align-middle text-right tabular-nums border-l border-[#e5f0e6] font-bold text-[#1b5e20]" }
const _hoisted_24 = {
  key: 0,
  class: "px-2.5 py-2 align-middle whitespace-nowrap",
  "data-cy": "fee-recipient-status"
}
const _hoisted_25 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 text-[11px] text-[#666]",
  "data-cy": "fee-recipient-disb-spinner"
}
const _hoisted_26 = {
  key: 1,
  class: "inline-flex items-center gap-2"
}
const _hoisted_27 = { class: "inline-flex items-center gap-1 px-2.5 py-[3px] rounded-full text-[11px] font-semibold bg-[#dcfce7] text-[#166534] border border-[#bbf7d0]" }
const _hoisted_28 = { class: "undo-disabled-btn" }
const _hoisted_29 = {
  key: 2,
  class: "inline-flex flex-col items-end gap-1"
}
const _hoisted_30 = { class: "inline-flex items-center gap-2" }
const _hoisted_31 = { class: "inline-flex items-center gap-1 px-2.5 py-[3px] rounded-full text-[11px] font-semibold bg-[rgba(var(--v-theme-error),0.08)] text-error border border-[rgba(var(--v-theme-error),0.3)]" }
const _hoisted_32 = {
  key: 0,
  class: "text-[10px] text-error max-w-[180px] text-right"
}
const _hoisted_33 = {
  key: 3,
  class: "inline-block px-2.5 py-[3px] rounded-full text-[11px] font-semibold bg-[#f1f5f9] text-[#475569] border border-[#e2e8f0]"
}
const _hoisted_34 = {
  key: 4,
  class: "inline-flex items-center gap-2"
}
const _hoisted_35 = { class: "px-2.5 py-2 align-middle text-center whitespace-nowrap" }
const _hoisted_36 = {
  key: 0,
  class: "fr-btn-spinner",
  "data-cy": "fee-recipient-saving-spinner"
}
const _hoisted_37 = {
  key: 0,
  class: "border-b border-[#e5f0e6]"
}
const _hoisted_38 = ["colspan"]
const _hoisted_39 = {
  key: 1,
  "data-cy": "fee-recipient-add-row"
}
const _hoisted_40 = { class: "px-2.5 py-2 align-middle" }
const _hoisted_41 = { class: "px-2.5 py-2 align-middle" }
const _hoisted_42 = { class: "px-2.5 py-2 align-middle text-right tabular-nums" }
const _hoisted_43 = {
  key: 0,
  class: "px-2.5 py-2 align-middle"
}
const _hoisted_44 = { class: "px-2.5 py-2 align-middle text-center whitespace-nowrap" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = ["colspan"]
const _hoisted_47 = { class: "bg-[#f1faf4] border-t-2 border-[#c6ebcf]" }
const _hoisted_48 = { class: "px-2.5 py-2 align-middle font-semibold text-[#1b5e20]" }
const _hoisted_49 = { class: "px-2.5 py-2 align-middle text-right tabular-nums font-bold text-[#1b5e20]" }
const _hoisted_50 = {
  class: "px-2.5 py-2 align-middle text-right tabular-nums font-bold text-[#1b5e20]",
  "data-cy": "fee-recipient-firm-fee"
}
const _hoisted_51 = {
  class: "px-2.5 py-2 align-middle text-right tabular-nums text-[#555]",
  "data-cy": "fee-recipient-firm-expenses"
}
const _hoisted_52 = {
  class: "px-2.5 py-2 align-middle text-right tabular-nums border-l border-[#e5f0e6] font-bold text-[#1b5e20]",
  "data-cy": "fee-recipient-firm-total"
}
const _hoisted_53 = ["colspan"]
const _hoisted_54 = {
  key: 0,
  class: "mt-2.5 px-3 py-2 bg-[#fff3e0] border border-[#ffcc80] rounded text-xs text-[#e65100]",
  "data-cy": "fee-recipients-over-100-hint"
}

import { computed, onMounted, reactive, ref } from 'vue';
import { storeToRefs } from 'pinia';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useFeeRecipientsStore } from '@/stores/useFeeRecipientsStore';
import { useInlineRecipientEditor, MAX_FEE_RECIPIENTS } from './feeRecipients/useInlineRecipientEditor';
import FeeRecipientVendorPicker from './feeRecipients/FeeRecipientVendorPicker.vue';
import FeeRecipientSubmitConfirmDialog from './feeRecipients/FeeRecipientSubmitConfirmDialog.vue';
import { useSettlementStore } from '@/modules/matters/settlement/stores/useSettlementStore';
import { useDisbursements } from './settlement/composables/useDisbursements';
import { feeRecipientRowKey, undoBlockedReasonFallback } from '@/utils/disbursementHelpers';
import { formatCurrency } from '@/services/utils';
import EventTracker from '@/services/eventTracker';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import AlertBar from '@/components/AlertBar.vue';
import QboIcon from '@/components/QboIcon.vue';
import type {
  ComputedBreakdown,
  ExpenseArrangement,
  FeeRecipientRole,
  MatterRecipientData as MatterRecipient,
} from '@/models/settlementTypes';
import type { DisbursementRowView } from './settlement/composables/useDisbursements';
import { EXPENSE_ARRANGEMENT } from '@/constants/settlementConstants';

const ESTIMATE_TOOLTIP = 'Calculated when the settlement is finalized based on the recovery amount.';
/** BR-020 — only shown under Client Pays As They Go, where the figure is a net advance the firm
 *  expects reimbursed, not a straight expense total. */
const CLIENT_PAYS_EXPENSES_TOOLTIP =
  "This doesn't include any payments the client made prior to settlement. Enter only the net amount this co-counsel firm advanced without client reimbursement — this amount will be included in their disbursement at settlement.";

const AMBER = '#f59e0b';


export default /*@__PURE__*/_defineComponent({
  __name: 'MatterFeeRecipientsTab',
  props: {
    stateParams: {},
    tracking: {}
  },
  setup(__props: any) {

const props = __props;

const ROLE_OPTIONS: { label: string; value: FeeRecipientRole }[] = [
  { label: 'Co-Counsel', value: 'coCounsel' },
  { label: 'Referring Attorney', value: 'referringAttorney' },
];

const clientMatterStore = useClientMatterStore();
const { features, company } = storeToRefs(useMeStore());
const store = useFeeRecipientsStore();
const { recipients, isLocked, uiState } = storeToRefs(store);

// Amber used for the disbursement Retry action — mirrors SettlementDisbursementTable.vue.
const settlementStore = useSettlementStore();
const { data: settlementData } = storeToRefs(settlementStore);

const confirmUndoDialogRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);
const undoMessage = ref('');
/** Content mirrors MatterLiensTab.vue's own Undo Submit dialog (handleRowUndo) — same
 *  "delete the QuickBooks check … and revert to {priorState}" structure — since a
 *  fee-recipient undo deletes a QBO check the same way a lien undo does
 *  (CoCounselDisbursementService.ExecuteUndoAsync mirrors LienService's). Left
 *  scoped to this tab: the Step 6 Settlement Disbursement table's own Undo dialog
 *  keeps its existing simpler wording. */
async function confirmUndo(recipientLabel: string): Promise<boolean> {
  const row = disbRows.value.find((r) => r.recipientName === recipientLabel);
  undoMessage.value = `This will delete the QuickBooks check for "${recipientLabel}"${
    row ? ` — ${formatCurrency(row.amount)}` : ''
  } and revert the disbursement to Pending.`;
  if (!confirmUndoDialogRef.value) return false;
  return confirmUndoDialogRef.value.open();
}

/** Same disbursement submit/undo machinery as the Settlement tab's Step 6 table
 *  (useDisbursements) so a fee recipient can be pushed to QuickBooks straight from
 *  this tab once the settlement is locked. Matched by settlementFeeRecipientId —
 *  NOT matterSettlementRecipientId, which identifies a different (matter-level)
 *  record than the disbursement endpoints operate on. */
const {
  rows: disbRows,
  anyBusy: disbAnyBusy,
  submitRow: submitDisbRow,
  undoRow: undoDisbRow,
} = useDisbursements({ confirmUndo });

/** True until the mount-time settlement→disbursements chain (see onMounted) settles, then
 *  false forever after — deliberately NOT the same as useDisbursements' own `loading`, which
 *  flips true again on every later submit/undo refresh. Gating the Status column's spinner on
 *  that instead would flash every row back to a generic spinner on each action (the busy row
 *  already has its own "Submitting…/Undoing…" state below); this flag only covers the one-time
 *  initial gap where the recipients table has rendered but disbursement rows haven't arrived. */
const disbInitialLoad = ref(true);

const disbRowByKey = computed(() =>
  new Map<string, DisbursementRowView>(disbRows.value.map((r) => [r.key, r])),
);

function disbRowFor(settlementFeeRecipientId: string | null): DisbursementRowView | undefined {
  if (!settlementFeeRecipientId) return undefined;
  return disbRowByKey.value.get(feeRecipientRowKey(settlementFeeRecipientId));
}

/** Gates the whole-table skeleton. Once locked, stays open through `disbInitialLoad` too, so
 *  the table paints once fully-formed (recipients + real Status/Submit state) instead of in two
 *  visible waves — recipients first, then every row's Status cell repainting a beat later. Safe
 *  to combine with `isLocked` here (unlike the Status column's own spinner) because this is the
 *  one-time initial paint, not something that should re-trigger on a later submit/undo. */
const initialLoadPending = computed(
  () => (uiState.value.loading && !recipients.value.length) || (isLocked.value && disbInitialLoad.value),
);

/** The shared disbursements store marks a row in-flight the same way for submit and
 *  undo (a single `submittingKeys` list), so the 'in-progress' overlay can't tell
 *  them apart on its own. Tracked locally instead — mirrors MatterLiensTab.vue's
 *  own pushingIds/undoingIds split — so the spinner can say "Undoing…" rather than
 *  defaulting to "Submitting…" while a reversal is in flight. */
const undoingKeys = reactive(new Set<string>());

async function handleUndoDisbRow(row: DisbursementRowView): Promise<void> {
  undoingKeys.add(row.key);
  try {
    await undoDisbRow(row);
  } finally {
    undoingKeys.delete(row.key);
  }
}

/** Preview dialog before pushing to QuickBooks — mirrors MatterLiensTab.vue's
 *  handleRowPush (confirm → execute), covering both the first Submit and a
 *  post-error Retry with the same dialog. */
const submitConfirmRef = ref<InstanceType<typeof FeeRecipientSubmitConfirmDialog> | null>(null);

async function handleSubmitDisbRow(row: DisbursementRowView): Promise<void> {
  const confirmed = await submitConfirmRef.value?.open(row);
  if (!confirmed) return;
  await submitDisbRow(row);
}

const matterId = computed<string | null>(
  () => props.stateParams?.matterId ?? props.stateParams?.id ?? null,
);

const matter = ref<{ billing?: { type?: string } } | null>(null);
/** `null` until the matter fetch resolves — treated as "not disqualified yet" below. */
const isContingency = computed(() => matter.value?.billing?.type === 'contingency');
/** Defense-in-depth against direct URL nav — the tab bar already gates on this too.
 *  Permissive during the initial matter fetch so it doesn't flash-hide while loading. */
const visible = computed(
  () => !!features.value?.coCounsel && (matter.value === null || isContingency.value),
);

const confirmRemoveResetRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);
const confirmEditResetRef = ref<InstanceType<typeof LlConfirmationDialog> | null>(null);

const editor = useInlineRecipientEditor(
  matterId,
  recipients,
  async () => !!(await confirmRemoveResetRef.value?.open()),
  async () => !!(await confirmEditResetRef.value?.open()),
);

const addDisabledReason = computed<string>(() => {
  if (isLocked.value) return 'Fee recipients are locked while a settlement is in progress.';
  if (!editor.canAddMore.value) return `Maximum of ${MAX_FEE_RECIPIENTS} fee recipients allowed`;
  if (editor.isAdding.value) return 'Finish adding this recipient first';
  return '';
});

/** Live total (draft where touched, saved otherwise) — owned by the editor so the inline hint here
 *  and the snackbar it raises can't drift apart. */
const totalPercentage = editor.totalPercentage;
const retainedPercentage = computed(() => Math.max(0, 100 - totalPercentage.value));
const firmName = computed(() => company.value?.name || 'Your Firm');

/** `null` when the matter has no settlement yet (or the fetch failed) — the recipients endpoint
 *  doesn't carry the arrangement, so it's read from the settlement store instead. */
const expenseArrangement = computed(() => settlementData.value?.expenseArrangement ?? null);

/**
 * Generating-firm figures (FRD §3.5 "Generating Firm Row"). MatterRecipientsResponse covers
 * outside recipients only — it returns nothing for the firm's own row — so these come from the
 * settlement summary instead: `generatingFirmRetainedAmount` for the fee, and `totalExpenses`
 * for expenses (the backend deliberately keeps co-counsel expenses *out* of that figure and
 * reports them separately as `coCounselExpensesTotal`, so it is already the firm's own share).
 * Total mirrors the recipient rows: fee + expenses.
 */
const settlementBreakdown = computed(() => settlementData.value?.computed ?? null);
const firmFeeAmount = computed(() => settlementBreakdown.value?.generatingFirmRetainedAmount ?? null);
const firmExpenses = computed(() => settlementBreakdown.value?.totalExpenses ?? null);
/** `null` — not 0 — while either input is missing, so the row falls back to "—" rather than
 *  showing a $0.00 that reads as a real computed answer. */
const firmTotal = computed(() =>
  firmFeeAmount.value == null && firmExpenses.value == null
    ? null
    : (firmFeeAmount.value ?? 0) + (firmExpenses.value ?? 0),
);
/** The FE alias for the backend's `ClientPays` (spec calls it ClientPaysAsTheyGo). */
const isClientPaysAsTheyGo = computed(() => expenseArrangement.value === EXPENSE_ARRANGEMENT.CLIENT);

const expensesTooltip = computed<string>(() => {
  if (isClientPaysAsTheyGo.value) return CLIENT_PAYS_EXPENSES_TOOLTIP;
  return isLocked.value ? '' : ESTIMATE_TOOLTIP;
});

function roleLabel(role: FeeRecipientRole): string {
  return ROLE_OPTIONS.find((option) => option.value === role)?.label ?? role;
}

onMounted(async () => {
  if (!matterId.value) return;
  const [fetchedMatter] = await Promise.all([
    clientMatterStore.getMatterById(matterId.value).catch((): null => null),
    // A matter with no settlement yet is the normal case here, not an error — it just means
    // there's no expense arrangement to drive the BR-020 info dot, and no disbursements to submit.
    // Chained (not awaited separately after the Promise.all below) so the disbursements read
    // races the recipients fetch instead of trailing a full extra round-trip behind it. Recipients
    // still resolve first in practice (one call vs. this two-hop chain); `initialLoadPending` keeps
    // the whole table's skeleton open through this chain (when locked) so the table paints once,
    // fully-formed, instead of recipients rendering first and every row's Status cell repainting a
    // beat later. loadDisbursements() itself no-ops if settlementId never resolved (no settlement
    // on this matter yet) — disbInitialLoad still flips false either way (the tsconfig's ES2017
    // lib has no Promise.finally, hence the onFulfilled/onRejected pair below instead) so the
    // fallback badge (correctly, since there's nothing to submit) takes over instead of spinning
    // forever.
    settlementStore
      .load(matterId.value)
      .then(() => settlementStore.loadDisbursements())
      .then(
        () => {
          disbInitialLoad.value = false;
        },
        (err) => {
          disbInitialLoad.value = false;
          throw err;
        },
      ),
    store.fetchRecipients(matterId.value),
  ]);
  matter.value = fetchedMatter as { billing?: { type?: string } } | null;

  if (props.tracking && !uiState.value.error) {
    EventTracker.trackEvent(props.tracking, 'Fee Recipients', 'Tab Viewed', {
      matterId: matterId.value,
      recipientCount: recipients.value.length,
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isLocked))
          ? (_openBlock(), _createBlock(AlertBar, {
              key: 0,
              type: "info",
              variant: "tonal",
              class: "mt-0 mx-6 mb-4",
              "data-cy": "fee-recipients-locked-banner"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "font-weight-bold" }, "Fee recipients are locked.", -1),
                _createTextVNode(" The settlement has been finalized. Restart the settlement flow to make changes. ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (initialLoadPending.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_skeleton_loader, {
                type: "heading",
                class: "mb-4",
                elevation: "0"
              }),
              _createVNode(_component_v_skeleton_loader, {
                type: "table-row-divider@3",
                class: "w-full",
                elevation: "0"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "text-base font-bold text-[#1a1a1a] mb-0.5" }, "Fee Recipients"),
                  _createElementVNode("div", { class: "text-xs text-[#666]" }, " Manage co-counsel and referring attorney fee splits for this matter. Recipients auto-load into Step 3 of the Settlement Wizard . ")
                ], -1)),
                _createVNode(LlTooltip, {
                  location: "top",
                  disabled: !addDisabledReason.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(addDisabledReason.value), 1)
                  ]),
                  activator: _withCtx(() => [
                    _createVNode(LlSecondaryButton, {
                      "prepend-icon": "mdi-plus",
                      color: "primary",
                      size: "small",
                      disabled: !!addDisabledReason.value,
                      "data-cy": "add-fee-recipient",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor).startAdd()))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("Add Recipient", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_7, [
                      _cache[22] || (_cache[22] = _createElementVNode("th", { class: "px-2.5 py-2 text-left font-semibold text-[#1b5e20] whitespace-nowrap min-w-[180px]" }, "Recipient Name", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("th", { class: "px-2.5 py-2 text-left font-semibold text-[#1b5e20] whitespace-nowrap min-w-[180px]" }, "Role", -1)),
                      _createElementVNode("th", _hoisted_8, [
                        _cache[13] || (_cache[13] = _createTextVNode(" % of Total Fee ", -1)),
                        _createVNode(LlTooltip, { location: "top" }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("Attorney fees round down to the nearest cent; any leftover goes to your firm's share so the client is never overcharged.", -1)
                          ]))]),
                          activator: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("span", {
                              class: "inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border-[1.3px] border-current text-[9px] not-italic font-bold ml-1 align-middle cursor-help",
                              "data-cy": "fee-recipient-percentage-info"
                            }, "i", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_9, [
                        _cache[16] || (_cache[16] = _createTextVNode(" Fee Amount ", -1)),
                        (!_unref(isLocked))
                          ? (_openBlock(), _createBlock(LlTooltip, {
                              key: 0,
                              location: "top"
                            }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode("Calculated when the settlement is finalized based on the recovery amount.", -1)
                              ]))]),
                              activator: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("span", { class: "inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border-[1.3px] border-current text-[9px] not-italic font-bold ml-1 align-middle cursor-help" }, "i", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("th", _hoisted_10, [
                        _cache[18] || (_cache[18] = _createTextVNode(" Expenses ", -1)),
                        (expensesTooltip.value)
                          ? (_openBlock(), _createBlock(LlTooltip, {
                              key: 0,
                              location: "top"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(expensesTooltip.value), 1)
                              ]),
                              activator: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("span", {
                                  class: "inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border-[1.3px] border-current text-[9px] not-italic font-bold ml-1 align-middle cursor-help",
                                  "data-cy": "fee-recipient-expenses-info"
                                }, "i", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("th", _hoisted_11, [
                        _cache[21] || (_cache[21] = _createTextVNode(" Total ", -1)),
                        (!_unref(isLocked))
                          ? (_openBlock(), _createBlock(LlTooltip, {
                              key: 0,
                              location: "top"
                            }, {
                              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createTextVNode("Calculated when the settlement is finalized based on the recovery amount.", -1)
                              ]))]),
                              activator: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("span", { class: "inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border-[1.3px] border-current text-[9px] not-italic font-bold ml-1 align-middle cursor-help" }, "i", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(isLocked))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Status"))
                        : _createCommentVNode("", true),
                      _cache[24] || (_cache[24] = _createElementVNode("th", { class: "px-2.5 py-2 text-left font-semibold text-[#1b5e20] whitespace-nowrap w-16" }, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (!_unref(recipients).length && !_unref(editor).isAdding.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                          _createElementVNode("td", {
                            class: "text-center align-middle py-6 px-2.5 italic text-[#888] text-[12.5px]",
                            colspan: _unref(isLocked) ? 8 : 7,
                            "data-cy": "fee-recipients-empty"
                          }, " No recipients added. Click \"+ Add Recipient\" to begin. ", 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipients), (recipient) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: recipient.matterSettlementRecipientId
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass(_unref(editor).rowErrors.value[recipient.matterSettlementRecipientId] ? '' : 'border-b border-[#e5f0e6]'),
                          "data-cy": "fee-recipient-row"
                        }, [
                          _createElementVNode("td", _hoisted_15, [
                            (_unref(isLocked))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(recipient.vendorDisplayName), 1))
                              : (_openBlock(), _createBlock(FeeRecipientVendorPicker, {
                                  key: 1,
                                  "model-value": _unref(editor).draftFor(recipient).vendorId,
                                  "vendor-search": _unref(editor).vendorSearchFor(recipient),
                                  "available-vendors": _unref(editor).availableVendorsFor(recipient),
                                  "data-cy": "fee-recipient-vendor-input",
                                  "onUpdate:modelValue": (v) => { _unref(editor).draftFor(recipient).vendorId = v; _unref(editor).onFieldChange(recipient); }
                                }, null, 8, ["model-value", "vendor-search", "available-vendors", "onUpdate:modelValue"]))
                          ]),
                          _createElementVNode("td", _hoisted_17, [
                            (_unref(isLocked))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(roleLabel(recipient.role)), 1))
                              : (_openBlock(), _createBlock(LlSelect, {
                                  key: 1,
                                  "model-value": _unref(editor).draftFor(recipient).role,
                                  items: ROLE_OPTIONS,
                                  "item-title": "label",
                                  "item-value": "value",
                                  "return-object": false,
                                  density: "compact",
                                  "hide-details": "",
                                  "data-cy": "fee-recipient-role-input",
                                  "onUpdate:modelValue": (role) => { _unref(editor).draftFor(recipient).role = role; _unref(editor).onFieldChange(recipient); }
                                }, null, 8, ["model-value", "onUpdate:modelValue"]))
                          ]),
                          _createElementVNode("td", _hoisted_19, [
                            (_unref(isLocked))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(recipient.percentage.toFixed(4)) + " %", 1))
                              : (_openBlock(), _createBlock(LlTextField, {
                                  key: 1,
                                  "model-value": _unref(editor).draftFor(recipient).percentage,
                                  type: "number",
                                  min: 0,
                                  max: 100,
                                  step: "0.0001",
                                  suffix: "%",
                                  density: "compact",
                                  "hide-details": "",
                                  "incoming-class": "text-right",
                                  "data-cy": "fee-recipient-percentage-input",
                                  "onUpdate:modelValue": (v) => { _unref(editor).draftFor(recipient).percentage = Number(v); _unref(editor).onFieldChange(recipient); }
                                }, null, 8, ["model-value", "onUpdate:modelValue"]))
                          ]),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(isLocked) ? _unref(formatCurrency)(recipient.feeAmount ?? 0) : '—'), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(isLocked) ? _unref(formatCurrency)(recipient.expenses ?? 0) : '—'), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(isLocked) ? _unref(formatCurrency)(recipient.total ?? 0) : '—'), 1),
                          (_unref(isLocked))
                            ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                (disbRowFor(recipient.settlementFeeRecipientId))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (disbRowFor(recipient.settlementFeeRecipientId)!.state === 'in-progress')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                            _createVNode(_component_v_progress_circular, {
                                              indeterminate: "",
                                              size: "14",
                                              width: "2",
                                              color: "success"
                                            }),
                                            _createTextVNode(" " + _toDisplayString(undoingKeys.has(disbRowFor(recipient.settlementFeeRecipientId)!.key) ? 'Undoing…' : 'Submitting…'), 1)
                                          ]))
                                        : (disbRowFor(recipient.settlementFeeRecipientId)!.state === 'done')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                              _createElementVNode("span", _hoisted_27, [
                                                _createVNode(_component_v_icon, { size: "12" }, {
                                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                    _createTextVNode("mdi-check-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _cache[26] || (_cache[26] = _createTextVNode(" Submitted to QuickBooks ", -1))
                                              ]),
                                              (disbRowFor(recipient.settlementFeeRecipientId)!.canUndo)
                                                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                                                    key: 0,
                                                    color: AMBER,
                                                    variant: "text",
                                                    size: "small",
                                                    disabled: _unref(disbAnyBusy),
                                                    "data-cy": `fee-recipient-disb-undo-${recipient.matterSettlementRecipientId}`,
                                                    onClick: ($event: any) => (handleUndoDisbRow(disbRowFor(recipient.settlementFeeRecipientId)!))
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                      _createTextVNode("Undo", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["disabled", "data-cy", "onClick"]))
                                                : (_openBlock(), _createBlock(LlTooltip, {
                                                    key: 1,
                                                    location: "top"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(disbRowFor(recipient.settlementFeeRecipientId)!.undoBlockedReason || _unref(undoBlockedReasonFallback)(disbRowFor(recipient.settlementFeeRecipientId)!.key)), 1)
                                                    ]),
                                                    activator: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_28, [
                                                        _createVNode(LlSecondaryButton, {
                                                          color: AMBER,
                                                          variant: "text",
                                                          size: "small",
                                                          disabled: ""
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                            _createTextVNode("Undo", -1)
                                                          ]))]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                            ]))
                                          : (disbRowFor(recipient.settlementFeeRecipientId)!.state === 'error')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                _createElementVNode("span", _hoisted_30, [
                                                  _createElementVNode("span", _hoisted_31, [
                                                    _createVNode(_component_v_icon, { size: "12" }, {
                                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                        _createTextVNode("mdi-alert-circle", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[30] || (_cache[30] = _createTextVNode(" Failed ", -1))
                                                  ]),
                                                  _createVNode(LlSecondaryButton, {
                                                    color: AMBER,
                                                    variant: "flat",
                                                    size: "small",
                                                    class: "text-white",
                                                    disabled: _unref(disbAnyBusy),
                                                    "data-cy": `fee-recipient-disb-retry-${recipient.matterSettlementRecipientId}`,
                                                    onClick: ($event: any) => (handleSubmitDisbRow(disbRowFor(recipient.settlementFeeRecipientId)!))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(QboIcon, {
                                                        size: "14",
                                                        class: "mr-1"
                                                      }),
                                                      _cache[31] || (_cache[31] = _createTextVNode("Retry", -1))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["disabled", "data-cy", "onClick"])
                                                ]),
                                                (disbRowFor(recipient.settlementFeeRecipientId)!.message)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(disbRowFor(recipient.settlementFeeRecipientId)!.message), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (disbRowFor(recipient.settlementFeeRecipientId)!.state === 'blocked')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Pending"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "inline-block px-2.5 py-[3px] rounded-full text-[11px] font-semibold bg-[#f1f5f9] text-[#475569] border border-[#e2e8f0]" }, "Pending", -1)),
                                                  _createVNode(LlSecondaryButton, {
                                                    color: "primary",
                                                    variant: "outlined",
                                                    size: "small",
                                                    disabled: _unref(disbAnyBusy),
                                                    "data-cy": `fee-recipient-disb-submit-${recipient.matterSettlementRecipientId}`,
                                                    onClick: ($event: any) => (handleSubmitDisbRow(disbRowFor(recipient.settlementFeeRecipientId)!))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(QboIcon, {
                                                        size: "14",
                                                        class: "mr-1"
                                                      }),
                                                      _cache[32] || (_cache[32] = _createTextVNode("Submit", -1))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["disabled", "data-cy", "onClick"])
                                                ]))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass(["inline-flex items-center gap-1 px-2.5 py-[3px] rounded-full text-[11px] font-semibold", recipient.status === 'Submitted'
                      ? 'bg-[#dcfce7] text-[#166534] border border-[#bbf7d0]'
                      : 'bg-[#f1f5f9] text-[#475569] border border-[#e2e8f0]'])
                                    }, [
                                      (recipient.status === 'Submitted')
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            size: "12"
                                          }, {
                                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                              _createTextVNode("mdi-check-circle", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(recipient.status === 'Submitted' ? 'Submitted to QuickBooks' : 'Pending'), 1)
                                    ], 2))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_35, [
                            (_unref(editor).isSaving(recipient))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                              : (!_unref(isLocked))
                                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                                    key: 1,
                                    icon: "mdi-trash-can-outline",
                                    variant: "text",
                                    color: "error",
                                    size: "small",
                                    title: "Remove",
                                    "aria-label": "Remove recipient",
                                    "data-cy": "fee-recipient-remove",
                                    onClick: ($event: any) => (_unref(editor).remove(recipient))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                          ])
                        ], 2),
                        (_unref(editor).rowErrors.value[recipient.matterSettlementRecipientId])
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                              _createElementVNode("td", {
                                colspan: _unref(isLocked) ? 8 : 7,
                                class: "px-2.5 pt-0 pb-2 text-[11px] text-error",
                                "data-cy": "fee-recipient-row-error"
                              }, _toDisplayString(_unref(editor).rowErrors.value[recipient.matterSettlementRecipientId]), 9, _hoisted_38)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (_unref(editor).isAdding.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                          _createElementVNode("td", _hoisted_40, [
                            (_unref(editor).addDraft.value)
                              ? (_openBlock(), _createBlock(FeeRecipientVendorPicker, {
                                  key: 0,
                                  "model-value": _unref(editor).addDraft.value.vendorId,
                                  "vendor-search": _unref(editor).addVendorSearch,
                                  "available-vendors": _unref(editor).availableVendorsForAdd.value,
                                  "data-cy": "fee-recipient-vendor-input",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => { if (_unref(editor).addDraft.value) _unref(editor).addDraft.value.vendorId = v; _unref(editor).onAddFieldChange(); })
                                }, null, 8, ["model-value", "vendor-search", "available-vendors"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_41, [
                            (_unref(editor).addDraft.value)
                              ? (_openBlock(), _createBlock(LlSelect, {
                                  key: 0,
                                  modelValue: _unref(editor).addDraft.value.role,
                                  "onUpdate:modelValue": [
                                    _cache[2] || (_cache[2] = ($event: any) => ((_unref(editor).addDraft.value.role) = $event)),
                                    _cache[3] || (_cache[3] = ($event: any) => (_unref(editor).onAddFieldChange()))
                                  ],
                                  items: ROLE_OPTIONS,
                                  "item-title": "label",
                                  "item-value": "value",
                                  "return-object": false,
                                  density: "compact",
                                  "hide-details": "",
                                  "data-cy": "fee-recipient-role-input"
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_42, [
                            (_unref(editor).addDraft.value)
                              ? (_openBlock(), _createBlock(LlTextField, {
                                  key: 0,
                                  modelValue: _unref(editor).addDraft.value.percentage,
                                  "onUpdate:modelValue": [
                                    _cache[4] || (_cache[4] = ($event: any) => ((_unref(editor).addDraft.value.percentage) = $event)),
                                    _cache[5] || (_cache[5] = ($event: any) => (_unref(editor).onAddFieldChange()))
                                  ],
                                  modelModifiers: { number: true },
                                  type: "number",
                                  min: 0,
                                  max: 100,
                                  step: "0.0001",
                                  suffix: "%",
                                  density: "compact",
                                  "hide-details": "",
                                  "incoming-class": "text-right",
                                  "data-cy": "fee-recipient-percentage-input"
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _cache[35] || (_cache[35] = _createElementVNode("td", { class: "px-2.5 py-2 align-middle text-right tabular-nums font-bold text-[#1b5e20]" }, "—", -1)),
                          _cache[36] || (_cache[36] = _createElementVNode("td", { class: "px-2.5 py-2 align-middle text-right tabular-nums text-[#555]" }, "—", -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("td", { class: "px-2.5 py-2 align-middle text-right tabular-nums border-l border-[#e5f0e6] font-bold text-[#1b5e20]" }, "—", -1)),
                          (_unref(isLocked))
                            ? (_openBlock(), _createElementBlock("td", _hoisted_43))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_44, [
                            _createVNode(LlSecondaryButton, {
                              icon: "mdi-check",
                              variant: "text",
                              color: "primary",
                              size: "small",
                              loading: _unref(editor).addSaving.value,
                              disabled: _unref(editor).addSaving.value,
                              "aria-label": "Save recipient",
                              "data-cy": "fee-recipient-save",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(editor).saveAdd()))
                            }, null, 8, ["loading", "disabled"]),
                            _createVNode(LlSecondaryButton, {
                              icon: "mdi-close",
                              variant: "text",
                              size: "small",
                              class: "ml-1.5",
                              disabled: _unref(editor).addSaving.value,
                              "aria-label": "Cancel adding recipient",
                              "data-cy": "fee-recipient-cancel",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(editor).cancelAdd()))
                            }, null, 8, ["disabled"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(editor).isAdding.value && _unref(editor).rowErrors.value['__new__'])
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                          _createElementVNode("td", {
                            colspan: _unref(isLocked) ? 8 : 7,
                            class: "px-2.5 pt-0 pb-2 text-[11px] text-error",
                            "data-cy": "fee-recipient-row-error"
                          }, _toDisplayString(_unref(editor).rowErrors.value['__new__']), 9, _hoisted_46)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", _hoisted_47, [
                      _createElementVNode("td", _hoisted_48, _toDisplayString(firmName.value), 1),
                      _cache[38] || (_cache[38] = _createElementVNode("td", { class: "px-2.5 py-2 align-middle text-xs text-[#555]" }, "Your firm", -1)),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(retainedPercentage.value.toFixed(4)) + " %", 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(isLocked) && firmFeeAmount.value != null ? _unref(formatCurrency)(firmFeeAmount.value) : '—'), 1),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(isLocked) && firmExpenses.value != null ? _unref(formatCurrency)(firmExpenses.value) : '—'), 1),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(_unref(isLocked) && firmTotal.value != null ? _unref(formatCurrency)(firmTotal.value) : '—'), 1),
                      _createElementVNode("td", {
                        class: "px-2.5 py-2 align-middle",
                        colspan: _unref(isLocked) ? 2 : 1
                      }, null, 8, _hoisted_53)
                    ])
                  ])
                ])
              ]),
              (_unref(editor).isOverAllocated.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Total recipient percentage exceeds 100%. Reduce percentages so your firm retains at least 0%. "))
                : _createCommentVNode("", true)
            ])),
        _createVNode(LlConfirmationDialog, {
          ref_key: "confirmRemoveResetRef",
          ref: confirmRemoveResetRef,
          title: "Reset Settlement to Step 1?",
          message: "This recipient has expenses recorded in an active settlement. Removing them will reset the settlement to Step 1. Remove and reset?",
          "confirm-text": "Remove and Reset",
          "toggle-text": "Cancel",
          "confirm-color": "error",
          "show-warning-icon": true,
          "data-cy": "fee-recipient-reset-confirmation"
        }, null, 512),
        _createVNode(LlConfirmationDialog, {
          ref_key: "confirmEditResetRef",
          ref: confirmEditResetRef,
          title: "Reset Settlement to Step 1?",
          message: "Changing the vendor or role will reset the settlement to Step 1, since this recipient's expenses were already confirmed. Continue?",
          "confirm-text": "Change and Reset",
          "toggle-text": "Cancel",
          "confirm-color": "error",
          "show-warning-icon": true,
          "data-cy": "fee-recipient-edit-reset-confirmation"
        }, null, 512),
        _createVNode(LlConfirmationDialog, {
          ref_key: "confirmUndoDialogRef",
          ref: confirmUndoDialogRef,
          title: "Undo Submit",
          message: undoMessage.value,
          "confirm-text": "Delete Check & Undo Submit",
          "toggle-text": "Cancel",
          "show-warning-icon": "",
          "data-cy": "fee-recipient-disb-undo-dialog"
        }, null, 8, ["message"]),
        _createVNode(FeeRecipientSubmitConfirmDialog, {
          ref_key: "submitConfirmRef",
          ref: submitConfirmRef
        }, null, 512)
      ]))
    : _createCommentVNode("", true)
}
}

})